export default "__VITE_ASSET__WHIWI9ab__"